import { LitElement, html } from "lit";
import { customElement } from "lit/decorators.js";
import { getGlobalStyleSheets } from "../../global-styles";

import * as TagNames from "./layouts.tagnames";

@customElement(TagNames.MainLayout)
export class AtlMainLayout extends LitElement {
  static styles = [...getGlobalStyleSheets()];

  declare condensed?: boolean;
  declare mainContainerClasses?: string;

  static properties = {
    condensed: { type: Boolean },
    mainContainerClasses: { attribute: "main-container-class", type: String },
  };

  render() {
    const classNames = [
      "flex-fill",
      "d-flex",
      "flex-column",
      "main-content-container",
    ];
    if (this.condensed) {
      classNames.push("sidebar-condensed");
    }
    if (this.mainContainerClasses) {
      classNames.push(this.mainContainerClasses);
    }

    return html`
      <div class="wrapper d-flex align-items-stretch">
        <span class="skip-to-content-container">
          <button
            type="button"
            class="btn btn-link skip-to-content-link"
            tabindex="0"
            aria-label="Skip To Content"
            @click="${this._handleSkipToContentClick}"
          >
            Skip to content
          </button>
        </span>
        <header class="header">
          <slot name="SidebarContainer"></slot>
        </header>
        <div class="${classNames.join(" ")}">
          <main role="main">
            <slot name="MainHeaderContainer"></slot>
            <div id="MainContentBody" class="container-fluid px-5 body-content">
              <slot name="Body"></slot>
            </div>
          </main>
          <slot name="FooterContainer"></slot>
        </div>
      </div>
    `;
  }

  _handleSkipToContentClick = () => {
    (document.activeElement as HTMLElement)?.blur();
    document
      .getElementById("MainContentBody")
      ?.scrollIntoView({ behavior: "smooth" });
  };
}
